// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyView3_container__SmWIN","icon":"EmptyView3_icon__3JkU4","text":"EmptyView3_text__3sMRV"};